import React from "react";
import { ICustomeGroup } from "../Interfaces/ICustomeGroup";
import { Chip } from "@mui/material";


interface IProps {
    idGroup: number;
    groupArray: ICustomeGroup[];
    fontSize?: string;
    notSmall?: boolean;
    height?: string | number;
    size?: "small" | "medium";
    onDelete?: (idGroup:number) => void;
}

type RoleStyle = { bg: string; color: string; border: string };

// Rollenspezifische, hochwertige Badge-Farben (PVTA-Stil).
const ROLE_STYLES: Record<number, RoleStyle> = {
    1: { bg: '#123d24', color: '#ffffff', border: 'transparent' },              // Präsid – kräftiges Dunkelgrün
    2: { bg: '#e8f1e8', color: '#1f4d2b', border: 'rgba(31, 77, 43, 0.25)' },   // AH-Vorstand – Grün
    3: { bg: '#efe4bd', color: '#6f5512', border: 'rgba(200, 169, 77, 0.55)' }, // Escheck-Team – warmes Gold
    4: { bg: '#eef0ee', color: '#5b625b', border: 'rgba(20, 35, 25, 0.14)' },   // Gäste – neutral
};

const FALLBACK_STYLE: RoleStyle = { bg: '#fdecea', color: '#b3261e', border: 'rgba(179, 38, 30, 0.35)' };


export const GroupChip:React.FC<IProps> = ({idGroup,groupArray,fontSize,height,size, onDelete}) => {
    const currentGroup = groupArray.find(x => x.id === idGroup);
    const roleStyle = currentGroup ? (ROLE_STYLES[currentGroup.id] ?? FALLBACK_STYLE) : FALLBACK_STYLE;

    return(
        <Chip
            label={currentGroup === undefined ? "FEHLER" : currentGroup.customGroup}
            sx={{
                height: height,
                fontSize: fontSize,
                mr: 0.5,
                borderRadius: 999,
                fontWeight: 600,
                backgroundColor: roleStyle.bg,
                color: roleStyle.color,
                border: '1px solid',
                borderColor: roleStyle.border,
                boxShadow: '0 4px 10px rgba(20, 35, 25, 0.08)',
                '& .MuiChip-deleteIcon': {
                    color: roleStyle.color,
                    opacity: 0.7,
                    '&:hover': { opacity: 1, color: roleStyle.color },
                },
            }}
            size={size === undefined ? "small" : size}
            onDelete={onDelete === undefined ? undefined : () => onDelete(idGroup)}
        />
    )
}
